import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import Button from '../../components/common/button/Button';
import Divide from '../../components/common/divide/Divide';
import Modal from '../../components/common/modal/Modal';
import SpendingAreaCard from '../../components/common/cards/spending-area-card/SpendingAreaCard';
import Jumbo from '../../components/common/jumbo/Jumbo';
import PeoplesBudgetEntries from '../../components/sections/peoples-budget-entries/PeoplesBudgetEntries';
import TwitterFeed from '../../components/common/twitter-feed/TwitterFeed';
import PeoplesBudgetStats from '../../components/sections/peoples-budget-stats/PeoplesBudgetStats';
import { Container, Grid, Cell } from '../../components/layout';

import Primary from '../../layouts/Primary';

import logo from '../../assets/images/budget-calc-logo.jpg';

import {
  pageActions
} from '../../reducks';

class Homepage extends Component {
  state = {
    deadlineModalActive: false,
    modalActive: false,
  }

  toggleYouTubeModal = () => {
    this.setState({
      modalActive: !this.state.modalActive,
    });
  }

  toggleDeadlineModal = () => {
    this.setState({
      deadlineModalActive: !this.state.deadlineModalActive,
    });
  }

  render() {
    const { _budget } = this.props;

    return (
      <div className="homepage-content-container">
        <Primary>
          <Container>
            <Jumbo>
              <Grid>
                <Cell size={{ desktop: '12', tablet: '12', phone: '6' }}>
                  <img src={logo} alt="Pepople's Budget Logo" width="150" />
                </Cell>
                <Cell size={{ desktop: '12', tablet: '12', phone: '6' }}>
                  <h2 className="c-jumbo__title">People's Budget</h2>
                </Cell>
              </Grid>

              <div className="c-jumbo__narrow-content">
                <Grid>
                  <Cell size={{ desktop: '12', tablet: '12', phone: '6' }}>
                    <div className="u-text-center">
                      {
                        moment().isAfter('2025-01-15') &&
                        <h2>Balancing the city's budget.</h2>
                      }
                      {
                        !moment().isAfter('2025-01-15') &&
                        <h2>How will you balance the city's budget?</h2>
                      }
                      {
                        moment().isAfter('2025-01-15') &&
                        <p>
                          The People’s Budget for 2024-2025 is now closed. Thank you to everyone who gave us your views. Newcastle City Council needs to make more budget savings over the next three years as a result of government cuts and rising unfunded cost pressures. We will use what you have told us to inform our final budget for 24-25. You can find out more about this on our website: <a href="https://www.newcastle.gov.uk/local-government/budget-performance-and-spend/council-plan-and-budget" target="_blank" rel="noopener noreferrer">Newcastle City Council plan and budget</a>. If you have questions you can contact us at: <a href="mailto:letstalk@newcastle.gov.uk" rel="noopener noreferrer">letstalk@newcastle.gov.uk</a>.
                        </p>
                      }
                      {
                        !moment().isAfter('2025-01-15') &&
                        <div>
                          <p>
                            The council needs to make more budget savings over the next three years as a result of government cuts and rising unfunded cost pressures.<br />
                            We are about to publish a draft plan for how we’ll approach that, with detailed proposals for 2025-26.
                          </p>
                          <p>
                            Help us to create a balanced budget for the city
                          </p>
                        </div>
                      }
                      <div className="c-button-group">
                        {(() => {
                          // console.log("moment().format()=" + moment().format());
                        })()}
                        {
                          !moment().isAfter('2025-01-15') &&
                          <Button href="/set-your-budget">Take the Budget Challenge</Button>
                        }
                        {
                          moment().isAfter('2025-01-15') &&
                          <a className="c-button" rel="noopener noreferrer" href="/peoples-budget">View the People's Budget</a>
                        }
                      </div>
                      <div className="htu-btn-container">
                        <a style={{ backgroundColor: '#58585a' }} className="c-button htu-home-btn" rel="noopener noreferrer" href="/how-to-use">How to use</a>
                      </div>
                    </div>
                  </Cell>
                </Grid>
              </div>
            </Jumbo>

            {
              this.state.deadlineModalActive &&
              <Modal handleClose={() => this.toggleDeadlineModal()}>
                <i className="c-modal__budget-icon fas fa-info" />
                <h2 className="c-modal__title">The Budget Challenge is now closed</h2>
                <p style={{ marginTop: 16 }}>
                  View the People's Budget to see what<br />the people of Newcastle thought.<br />
                </p>
                <div className="c-button-group" style={{ marginTop: 16 }}>
                  <Button href="/peoples-budget">View the People's Budget</Button>
                </div>
              </Modal>
            }

          </Container>
        </Primary>
      </div>
    );
  }
}

export default connect((state, ownProps) => {
  return {
    _budget: state.budget
  }
}, (dispatch, ownProps) => {
  return {
    anchorToAllBudgets: () => dispatch(pageActions.anchorToAllBudgets()),
  }
})(Homepage)



// WEBPACK FOOTER //
// ./src/pages/homepage/Homepage.jsx